import { render, staticRenderFns } from "./questionAnswerTree.vue?vue&type=template&id=a43e9e5a&scoped=true"
import script from "./questionAnswerTree.vue?vue&type=script&lang=js"
export * from "./questionAnswerTree.vue?vue&type=script&lang=js"
import style0 from "./questionAnswerTree.vue?vue&type=style&index=0&id=a43e9e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43e9e5a",
  null
  
)

export default component.exports